import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class WImage extends Vue { 
	@Prop () size!: string
    @Prop () url!: string
}